import config from '../config';

export const platform = (url: any) => `${config.platformURL}` + url;